// AAWTA-specific test IDs (single source of truth for the marketing site)
export const NAV = {
  root: 'aawta-nav',
  home: 'nav-link-home',
  summitOverview: 'nav-link-summit-overview',
  agenda: 'nav-link-agenda',
  speakers: 'nav-link-speakers',
  sponsorShowcase: 'nav-link-sponsor-showcase',
  exhibitorDirectory: 'nav-link-exhibitor-directory',
  gallery: 'nav-link-gallery',
  faq: 'nav-link-faq',
  venueHotels: 'nav-link-venue-hotels',
  downloads: 'nav-link-downloads',
  contact: 'nav-link-contact',
  becomeSponsor: 'nav-cta-become-sponsor',
  registerNow: 'nav-cta-register-now',
  mobileToggle: 'nav-mobile-toggle',
};

export const HERO = {
  becomeSponsor: 'hero-cta-become-sponsor',
  registerNow: 'hero-cta-register-now',
  downloadFlyer: 'hero-cta-download-flyer',
  flyerImage: 'hero-flyer-image',
};

export const SPONSORSHIP = {
  card: (slug) => `sponsor-card-${slug}`,
  learnMore: (slug) => `sponsor-learn-more-${slug}`,
  becomeSponsor: (slug) => `sponsor-become-${slug}`,
};

export const INQUIRY = {
  dialog: (type) => `inquiry-dialog-${type}`,
  name: 'inquiry-name',
  email: 'inquiry-email',
  organization: 'inquiry-organization',
  phone: 'inquiry-phone',
  role: 'inquiry-role',
  tier: 'inquiry-tier',
  boothPreference: 'inquiry-booth',
  amount: 'inquiry-amount',
  message: 'inquiry-message',
  submit: 'inquiry-submit',
  cancel: 'inquiry-cancel',
};

export const AGENDA = {
  section: 'agenda-section',
  item: (idx) => `agenda-item-${idx}`,
  downloadPdf: 'agenda-download-pdf',
};

export const VENUE = {
  section: 'venue-hotels-section',
  hotelInquiryCta: 'venue-hotel-inquiry-cta',
};

export const DOWNLOADS = {
  section: 'downloads-section',
  flyer: 'downloads-flyer',
  agenda: 'downloads-agenda',
  pitchDeck: 'downloads-pitch-deck',
  logo: 'downloads-logo',
};

export const REG_CTA = {
  section: 'registration-cta-section',
  registerNow: 'reg-cta-register-now',
  becomeSponsor: 'reg-cta-become-sponsor',
};

export const CONTACT = {
  section: 'contact-section',
  scheduleMeeting: 'contact-schedule-meeting',
  emailLink: 'contact-email-link',
  phoneLink: 'contact-phone-link',
  supportMission: 'contact-support-mission',
};

export const FOOTER = {
  root: 'aawta-footer',
  newsletterEmail: 'newsletter-email',
  newsletterSubmit: 'newsletter-submit',
  socialFacebook: 'social-facebook',
  socialInstagram: 'social-instagram',
  socialLinkedin: 'social-linkedin',
  socialYoutube: 'social-youtube',
};
